export const LANDING = "/";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const HOME = "/home";
export const PASSWORD_FORGET = "/pw-forget";
export const LIST_USERS = "/list_users";
export const ADD_USER = "/add_user";
export const USER_DETAILS = "/user_details";
export const ORDERS_LIST = "/orders_list";
export const ORDER_DETAILS = "/order_details";
export const LIST_PRODUCTS = "/list_products";
export const PRODUCT_DETAILS = "/product_details";
export const SIGN_OUT = "/signout";
